import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { css } from 'styled-components';
import { transitionAnimation } from "../animations";
import { getHexToRgb } from "../hexToRgb";
export var focusOutlineColors = {
  getDark: function getDark(theme) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
    return "rgba(".concat(getHexToRgb(theme.color.additional.dark.value), ", ").concat(opacity, ")");
  },
  getLight: function getLight(theme) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
    return "rgba(".concat(getHexToRgb(theme.color.additional.light.value), ", ").concat(opacity, ")");
  },
  getPrimary: function getPrimary(theme) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
    return "rgba(".concat(getHexToRgb(theme.color.primary[500].value), ", ").concat(opacity, ")");
  },
  getSystemNegative: function getSystemNegative(theme) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
    return "rgba(".concat(getHexToRgb(theme.color.system.negative[500].value), ", ").concat(opacity, ")");
  }
};
export var focusOutlinesStyles = {
  dark: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-shadow: 0 0 0 4px ", ";\n    ", "\n  "])), function (_ref) {
    var theme = _ref.theme;
    return focusOutlineColors.getDark(theme);
  }, transitionAnimation('box-shadow')),
  light: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    box-shadow: 0 0 0 4px ", ";\n    ", "\n  "])), function (_ref2) {
    var theme = _ref2.theme;
    return focusOutlineColors.getLight(theme);
  }, transitionAnimation('box-shadow')),
  primary: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    box-shadow: 0 0 0 4px ", ";\n    ", "\n  "])), function (_ref3) {
    var theme = _ref3.theme;
    return focusOutlineColors.getPrimary(theme);
  }, transitionAnimation('box-shadow'))
};